import { reactive } from 'vue'

let nextId = 0

const state = reactive({
  alerts: []
})

export const alertService = {
  success(message, duration = 1000) {
    this.show(message, 'success', duration)
  },

  error(message, duration = 1000) {
    this.show(message, 'error', duration)
  },

  info(message, duration = 1000) {
    this.show(message, 'info', duration)
  },

  show(message, type = 'info', duration = 1000) {
    const id = nextId++
    const alert = { id, message, type }

    state.alerts.push(alert)

    // Auto-dismiss after duration
    if (duration > 0) {
      setTimeout(() => {
        this.remove(id)
      }, duration)
    }

    return id
  },

  remove(id) {
    const index = state.alerts.findIndex(alert => alert.id === id)
    if (index !== -1) {
      state.alerts.splice(index, 1)
    }
  },

  clear() {
    state.alerts = []
  },

  getState() {
    return state
  }
}
